/** Printable flyer bullets: bold lead phrase + supporting detail (from About tab & FAQ). */

export interface WorkshopFlyerBullet {
  id: string;
  lead: string;
  detail: string;
}

export const WORKSHOP_FLYER_INTRO =
  'An SAA Step Workshop is a weekly online group working through the 12 steps together via Zoom. Workshops typically run 35–60 weeks, depending on group pace. This is our 12th annual workshop. In the 11 workshops we\'ve held since 2009, more than 200 people have worked all 12 Steps from start to finish.';

export const WORKSHOP_FLYER_WHY: WorkshopFlyerBullet[] = [
  {
    id: 'connection',
    lead: 'Healing happens in connection.',
    detail:
      'Recovery often begins in isolation, but working the steps alongside others gives structure, encouragement, and shared experience with people who understand. What might take years alone can often be accomplished in months when we walk the path together.',
  },
  {
    id: 'results',
    lead: 'Many find their strongest recovery here.',
    detail:
      'Participants often share that their best recovery has come while working the steps — establishing consistent clean time and real progress during and after the workshop.',
  },
  {
    id: 'welcome',
    lead: 'New or returning — you are welcome.',
    detail:
      'No prior step work is required. If you have worked some or all of the steps before, you are also welcome — to complete them, work them again, and deepen your recovery, or share your wisdom.',
  },
];

export const WORKSHOP_FLYER_FAQS: WorkshopFlyerBullet[] = [
  {
    id: 'who-for',
    lead: 'Who is it for?',
    detail:
      'Anyone with a desire to stop addictive sexual behavior, willing to work the steps, able to attend weekly, and comfortable online — like SAA meetings.',
  },
  {
    id: 'privacy',
    lead: 'Is my step work private?',
    detail: 'Yes — encrypted; only you can read it. Sharing with a sponsor or others is your choice.',
  },
  {
    id: 'weekly',
    lead: 'What happens each week?',
    detail:
      'Step reading, sharing, and encouragement. Between sessions: learn and record step work in Recovery Commons while working with your sponsor and others.',
  },
  {
    id: 'register',
    lead: 'How do I register?',
    detail:
      'Free Recovery Commons account → Workshop tab interest list → confirm attendance → Zoom link appears there.',
  },
  {
    id: 'sponsor',
    lead: 'Do I need a sponsor?',
    detail: 'Yes, to complete Step One. No sponsor yet? Join while you look for one.',
  },
  {
    id: 'join-late',
    lead: 'Miss the first meeting?',
    detail: 'Sign up and join when you are ready.',
  },
];
